module.exports = __webpack_public_path__ + "static/vending-machine-8e978850314847a31b956b32842041c7.jpg";